<template>
  <Teleport to="body">
    <div v-if="visible" class="modal-overlay" @click.self="handleClose">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ s__('Profile|Boards Feature') }}</h3>
          <button type="button" class="modal-close" @click="handleClose" aria-label="Close">
            <CloseIcon />
          </button>
        </div>

        <div class="modal-body">
          <div class="info-section">
            <p>
              {{
                s__(
                  'Profile|Boards allow you to visualize and organize tasks using a Kanban-style board interface. You can create columns, move tasks between columns, and customize your workflow.'
                )
              }}
            </p>

            <h4>{{ s__('Profile|Personal Boards') }}</h4>
            <p>
              {{
                s__(
                  'Profile|When enabled, you can create personal boards to organize your tasks across all projects. Personal boards are visible only to you.'
                )
              }}
            </p>

            <h4>{{ s__('Profile|Project Boards') }}</h4>
            <p>
              {{
                s__(
                  'Profile|Project boards are shared with all members of a project. Project owners can enable boards for their projects in project settings.'
                )
              }}
            </p>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-primary" @click="handleClose">
            {{ s__('Profile|Close') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { Teleport } from 'vue'
import { s__ } from '@/locale'
import CloseIcon from '../common/icons/CloseIcon.vue'
import { useBodyScrollLock } from '@/composables/useBodyScrollLock'

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['close'])

// Lock body scroll when modal is open
useBodyScrollLock(computed(() => props.visible))

function handleClose() {
  emit('close')
}
</script>

<style scoped>
.info-section {
  line-height: 1.6;
}

.info-section h4 {
  margin: 20px 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.info-section h4:first-child {
  margin-top: 0;
}

.info-section p {
  margin: 0 0 16px 0;
  color: #666;
}
</style>
